<template>
  <!-- <div class="md:w-full lg:w-2/3 xl:w-2/3"> -->
  <div style="width: 100%">
    <!-- <div> -->
    <div class="flex flex-col">
      <div class="flex items-center">
        <div style="width: 20px">
          <img src="@/assets/icons/magnifier.svg" />
        </div>

        <input
          v-model="search"
          v-on:focus="searchFocus()"
          v-on:blur="searchBlur($event)"
          type="text"
          name="supporter-search"
          placeholder="Search for supporters"
          class="supporters-search"
          @input="fetchSearchSuggestions"
          @keydown.escape.prevent="keyEscape"
        />
      </div>
      <div class="search-results">
        <div v-if="isLoading" class="loading-container">
          <img class="loading-icon" src="~@/assets/img/loading.svg" />
          <div>Searching...</div>
        </div>

        <ul
          v-if="!isLoading && displaySuggestions"
          @mouseleave="selectSuggestion = false"
          @mouseover="selectSuggestion = true"
          class="search-results-list"
        >
          <li
            :key="result.index"
            v-for="result in searchResults"
            v-on:click="giveSupporterDetail(result)"
            class="search-result align-middle"
          >
            <!-- ID -->
            <div class="md:w-1/12">
              <div class="search-result-content">
                {{ result.id }}
              </div>
            </div>

            <!-- NAME -->
            <div class="flex md:w-2/12">
              <div class="search-result-content supporter-name">
                {{ result.firstName || result.name }} {{ result.lastName }}
              </div>
            </div>

            <!-- EMAIL -->
            <div class="flex md:w-3/12">
              <img src="@/assets/icons/mail.svg" v-if="result.display.email" />
              <span class="search-result-content" v-if="result.display.email">{{ result.display.email.contact }}</span>
            </div>

            <!-- PHONE NUMBER -->
            <div class="flex md:w-3/12">
              <img src="@/assets/icons/phone.svg" v-if="result.display.phoneNumber" />
              <span class="search-result-content" v-if="result.display.phoneNumber">
                {{ result.display.phoneNumber.contact }}
              </span>
            </div>

            <!-- ADDRESS -->
            <div class="flex md:w-3/12">
              <img src="@/assets/icons/home.svg" v-if="result.display.address && result.display.address.addressLines" />
              <span v-if="result.display.address" class="search-result-content">{{
                result.display.address.addressLines
              }}</span>
            </div>

            <!-- GO -->
            <div class="flex md:w-1/12">
              <img src="@/assets/icons/chevron-right.svg" />
            </div>
          </li>

          <!-- VIEW MORE -->
          <li v-on:click="viewMoreResults()" v-if="searchResults && searchResultsTotal > 5" class="view-more">
            <span class="secondary border-none">View all results ({{ searchResultsTotal }})</span>
          </li>
        </ul>

        <div v-if="noResults" class="search-no-results">
          <div>No records to display ...</div>
        </div>

        <div v-if="minChars" class="search-no-results">
          <div>Please type {{ minInputLength }} or more characters</div>
        </div>
      </div>
    </div>
    <div @click="displaySuggestions = false" v-if="displaySuggestions && displayOverlay" class="search-overlay"></div>
  </div>
</template>

<script>
export default {
  name: 'supporterSearch',

  data() {
    return {
      search: '',
      searchResults: [],
      searchResultsTotal: 0,
      isLoading: false,
      timeout: null,
      delay: 450, // ms
      minInputLength: 3,
      lastTimestamp: Date.now(),
      fetchingDetails: false,
      displaySuggestions: false,
      selectSuggestion: false,
      total: undefined,
    };
  },

  props: {
    limit: {
      type: Number,
      default: 100,
    },
    clearAfterSearch: {
      type: Boolean,
      default: true,
    },
    displayOverlay: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    noResults() {
      return (
        !this.isLoading &&
        this.searchResults &&
        this.searchResults.length === 0 &&
        this.search &&
        this.search.length >= this.minInputLength &&
        this.displaySuggestions
      );
    },
    minChars() {
      return (
        !this.isLoading &&
        this.searchResults &&
        this.searchResults.length === 0 &&
        this.search &&
        this.search.length < this.minInputLength &&
        this.displaySuggestions
      );
    },
  },

  created() {
    this.search = this.$route.query.q;
  },

  methods: {
    searchBlur(event) {
      console.log('Search blur');
      console.log(event.target.classList);
      this.$emit('searching', false);
      this.isLoading = false;
      if (!this.selectSuggestion) {
        this.displaySuggestions = false;
      }
    },
    viewMoreResults() {
      // Navigate to the search result page
      this.$router.push({ name: 'supporter-search-results', query: { q: this.search } });
      this.displaySuggestions = false;
    },
    searchFocus() {
      this.displaySuggestions = true;
      this.$emit('searching', true);
    },
    clickOutside() {
      this.displaySuggestions = false;
    },
    keyEscape() {
      this.displaySuggestions = false;
      this.suggestions = [];
    },
    giveSupporterDetail(supporter) {
      this.$emit('click', supporter);
      if (this.clearAfterSearch) this.clearSearch();
    },
    clearSearch() {
      this.displaySuggestions = false;
      this.search = '';
      this.searchResults = [];
    },
    fetchSearchSuggestions() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      // In any case, if the input changed, the suggestions will change
      this.suggestions = [];

      if (this.search && this.search.length >= this.minInputLength) {
        this.displaySuggestions = true;
        this.isLoading = true;
        let timestamp = Date.now(); // timestamp for this api call
        this.lastTimestamp = timestamp; // 1 , 2 , 3
        this.timeout = setTimeout(() => {
          console.log('Fetch search', this.search);

          // Do search
          this.$store
            .dispatch('supporters/search', { text: this.search, limit: this.limit })
            .then((r) => {
              console.log('Search Result', r);
              this.total = r.data.total;
              this.searchResults = r.data.supporters
                .sort((a, b) => b.rank - a.rank)
                .slice(0, 6)
                .map((s) => {
                  console.log('s', s);
                  s.display = {};

                  // Get the primary email to display
                  s.display.email =
                    s.contacts.find((s) => s.type === 'email' && s.isPrimary === true) ||
                    s.contacts.find((s) => s.type === 'email');

                  // Get the primary phone number to display
                  s.display.phoneNumber =
                    s.contacts.find((s) => s.type === 'phone' && s.isPrimary === true) ||
                    s.contacts.find((s) => s.type === 'phone');

                  if (s.display.phoneNumber) {
                    s.display.phoneNumber.contact = s.display.phoneNumber.contact.replace(/\s/g, '');
                  }

                  // Get the primary address to display
                  s.display.address = s.addresses.find((s) => s.isPrimary === true) || s.addresses[0];

                  if (
                    s.display.address &&
                    s.display.address.addressLines &&
                    s.display.address.addressLines.includes('undefined')
                  ) {
                    delete s.display.address;
                  }

                  return s;
                });

              this.searchResultsTotal = r.data.total;
              this.isLoading = false;
              this.displaySuggestions = true;
            })
            .catch((err) => {
              console.error('Error Supporters search ', err);
              this.searchResultsTotal = 0;
              this.isLoading = false;
              this.displaySuggestions = true;
            });
        }, this.delay);
      } else {
        // this.displaySuggestions = false;
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// todo: move this to page variables
$left-menu-width: 224px;
$topbar-height: 64px;
$grey-main-background: #f9fafb;

// Components specific variables
$search-result-height: 56px;

.supporter-search {
  border-bottom: 1px solid #e5e7eb;
  outline: 0 !important;

  &:focus {
    outline: 0 !important;
  }
}

/* Change the white to any color */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  box-shadow: 0 0 0 30px white inset !important;
  -webkit-box-shadow: 0 0 0 30px white inset !important;
}

.search-results {
  @apply opacity-100 bg-white rounded-b-md z-50;
  z-index: 2000;
  width: calc(100vw - var($left-menu-width));
}

.search-result {
  width: 100%;
  padding-left: 32px;
  height: $search-result-height;
  display: flex;
  align-items: center;
  font-size: 700;
  cursor: pointer;
  border-bottom: 1px solid #e5e7eb;

  &:hover {
    background: $grey-main-background;
  }

  svg {
    margin: -11px 10px 0 10px;
  }

  &-content {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #9fa6b2;
    font-weight: 300;

    &.supporter-name {
      color: black;
      font-weight: 500;
    }
  }

  .result-chevron {
    margin-top: -2px !important;
  }

  img {
    @apply mr-2;
  }

  .search-result-content {
    display: inline-block;
  }
}

.view-more {
  height: $search-result-height;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  border-bottom: 1px solid #e5e7eb;
  cursor: pointer;

  &:hover {
    background-color: rgba(243, 244, 246, 1);
  }

  span {
    margin-right: 10px;
    box-shadow: none;
    color: rgba(16, 185, 129, var(--tw-bg-opacity));
  }
}

.search-overlay {
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: $topbar-height;
  left: $left-menu-width;
  width: calc(100vw - #{$left-menu-width});
  height: calc(100vh - #{$topbar-height});
  z-index: 200;
}

.loading-container {
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #9fa6b2;
  font-weight: 400;
  font-size: 11px;
  border-bottom: 1px solid #e5e7eb;

  .loading-icon {
    $loading-icon-size: 40px;
    width: $loading-icon-size;
    height: $loading-icon-size;
  }
}

.font-italic {
  font-style: italic;
}

.search-result-icon {
  display: inline-block;
}

.search-result {
  width: 100%;
  height: 45px;
}

.supporters-search {
  @apply outline-none border-none focus:outline-none focus:shadow-none;
}

.search-no-results {
  @apply flex justify-center p-4 font-light font-italic;
}
</style>
